import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { 
  ActivatedRouteSnapshot, 
  RouterStateSnapshot, 
  UrlTree 
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../../environments/environment';
import { UserStatus } from '../../../models';
import { OrganizationService } from '../../services/organization.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.authService.currentUser$.pipe(
      map(user => {
        console.log("user", user);
        if(environment.skipApiCheck){
            return true;
        }
        
        if(user && !this.authService.isTokenExpired()){
          if(user.status === UserStatus.PENDING) {
            if(route.url.toString().includes('verify-email')){
              return true;
            }
            this.router.navigate(['/auth/verify-email']);
          } else if(!this.authService.getHasCompletedOnboarding()){
            // Stripe returns to /subscription/success while the offer step is still open.
            if(route.url.toString().includes('onboarding') || route.url.toString().includes('subscription')){
              return true;
            }
            return this.router.createUrlTree(['/onboarding']);
          } else {
            // var organization = this.organizationService.getCurrentOrganization();
            // if(!organization){
            //   this.organizationService.initialize();
            //   // this.walletService.initialize();
            // }
            return true;
            // return true;
          }
        }
        
        // Store the attempted URL for redirecting
        return this.router.createUrlTree(['/auth/login'], {
          queryParams: { returnUrl: state.url }
        });
        
      })
    );
  }
}
